import { Card, useWindowWidth } from '@acceso/design-system';
import clsx from 'clsx';
import { useState } from 'react';

import { MOBILE_WIDTH } from '@/constants';

import { ChannelType } from '../../types';

import { BroadcastersDetail } from './components';

type BroadcastersDetailsCardProps = {
  broadcasters: ChannelType;
  isCollapsed: boolean;
  onCollapse: () => void;
  onUpdate: (broadcasters: ChannelType) => void;
};

export function BroadcastersDetailCard({
  onCollapse,
  isCollapsed,
  broadcasters,
  onUpdate,
}: BroadcastersDetailsCardProps) {
  const { width } = useWindowWidth();
  const isMobile = width < MOBILE_WIDTH;
  const [isOpen, setIsOpen] = useState(true);

  return (
    <Card
      className="w-full"
      title={broadcasters.name}
      isAccordion={isMobile}
      isCollapsable={!isMobile}
      isOpen={isOpen}
      collapseDirection="right"
      lineSeparator={true}
      isCollapsed={isCollapsed && !isMobile}
      onCollapse={onCollapse}
      onOpen={() => setIsOpen(!isOpen)}
      classes={{
        header: clsx(!isMobile && 'py-3'),
      }}
    >
      <div className="body flex flex-col gap-size-12 self-stretch">
        <BroadcastersDetail broadcasters={broadcasters} onUpdate={onUpdate} />
      </div>
    </Card>
  );
}
